export function buildScene3Sequence() {
  const dossier = [
    { index: 0, m1: './scene2/8. Допрос 1 кам 1.mov', m2: './scene2/8. Допрос 1 кам 2.mov' },
    { index: 1, m1: './scene2/10. Допрос 2 кам 1.mov', m2: './scene2/10. Допрос 2 кам 2 .mov' },
    { index: 2, m1: './scene2/11. Допрос 3 кам 1.mov', m2: './scene2/11. Допрос 3 кам 2.mov' },
    { index: 3, m1: './scene2/12 допрос 4  кам 1.mov', m2: './scene2/12 допрос 4 кам 2.mov' },
    { index: 4, m1: './scene2/13. Допрос 5 кам 1.mov', m2: './scene2/13. Допрос 5 кам 2.mov' },
  ];

  const steps = [];

  // 1. Старт (кнопка пропадает в onStartInvestigation)
  // 2. Аудио (intro)
  steps.push({ type: 'audio', urlRel: './scene2/0.Начало.mp3' });



// --- ИЗУЧЕНИЕ ДОСЬЕ (7 Персонажей) ---
  steps.push({ type: 'showNextButton', buttonText: 'Изучить досье' });
  steps.push({ type: 'waitNextButtonClick' });
  steps.push({ type: 'hideNextButton' });
  steps.push({
    type: 'dossier',
    delayMs: 60000, // 3 секунды для тестов (для продакшна изменить на 60000)
    cards: [
      '../../assets/cards/Астров.png',
      '../../assets/cards/Кочарян.png',
      '../../assets/cards/Кузнецов.png',
      '../../assets/cards/Петров.png',
      '../../assets/cards/Плот.png',
      '../../assets/cards/ферг.png',
      '../../assets/cards/Юсупова.png'
    ]
  });



  // 2. Телефон "сделать звонок"
  steps.push({ type: 'enablePhone', labelText: 'Совершить звонок' });
  steps.push({ type: 'waitPhoneClick' });
  steps.push({ type: 'disablePhone' });

  // 3. Остальные аудио (до видео)
  steps.push({ type: 'audio', urlRel: './scene2/14. Звонок между допросом 5 и 6 Далее выборы.mp3' });

  // 4. Кнопка "Смотреть допросы" -> Видео [0]
  steps.push({ type: 'showNextButton', buttonText: 'Смотреть допросы' });
  steps.push({ type: 'waitNextButtonClick' });
  steps.push({ type: 'hideNextButton' });
  steps.push({ type: 'videos', ...mapDossierToUrls(dossier[0]) });

  // 5. После видео [0]: телефон "Ответить на звонок" -> Аудио 9 -> Цикл
  steps.push({ type: 'enablePhone', labelText: 'Ответить на звонок' });
  steps.push({ type: 'waitPhoneClick' });
  steps.push({ type: 'disablePhone' });
  steps.push({ type: 'audio', urlRel: './scene2/9. Звонок после допроса 1.mp3' });

  // 6. Оставшиеся видео с кнопкой "Следующий допрос" перед каждым
  for (let i = 1; i < dossier.length; i++) {
    steps.push({ type: 'showNextButton', buttonText: 'Следующий допрос' });
    steps.push({ type: 'waitNextButtonClick' });
    steps.push({ type: 'hideNextButton' });
    steps.push({ type: 'videos', ...mapDossierToUrls(dossier[i]) });
  }
  // 7. Финальное аудио после всех видео
  steps.push({ type: 'enablePhone', labelText: 'Ответить на звонок' });
  steps.push({ type: 'waitPhoneClick' });
  steps.push({ type: 'disablePhone' });
  steps.push({ type: 'audio', urlRel: './scene2/14. Звонок между допросом 5 и 6 Далее выборы.mp3' });

  // 15. Допрос 6 (ВЫБОР)
  steps.push({ type: 'showChoiceButtons' });
  steps.push({
    type: 'waitChoiceAndPlay',
    soft: { m1: './scene2/15.1 допрос 6 вежливо кам 1.mov', m2: './scene2/15.1 допрос 6 вежливо кам 2.mov' },
    tense: { m1: './scene2/15.2 допрос 6 напряженно кам 1.mov', m2: './scene2/15.2 допрос 6 напряженно кам 2.mov' }
  });

  // 16. Звонок
  steps.push({ type: 'enablePhone', labelText: 'Ответить на звонок' });
  steps.push({ type: 'waitPhoneClick' });
  steps.push({ type: 'disablePhone' });
  steps.push({ type: 'audio', urlRel: './scene2/16. Звонок между допросом 6 и 7.mp3' });

  // 17. Допрос 7 (ЛИНЕЙНО, нет 17.2)
  steps.push({ type: 'showNextButton', buttonText: 'Следующий допрос' });
  steps.push({ type: 'waitNextButtonClick' });
  steps.push({ type: 'hideNextButton' });
  steps.push({ type: 'videos', urlRel1: './scene2/17.1. Допрос 7 кам 1.mov', urlRel2: './scene2/17.1. Допрос 7 кам 2.mov', leader: 'video1' });

  // 18. Звонок
  steps.push({ type: 'enablePhone', labelText: 'Ответить на звонок' });
  steps.push({ type: 'waitPhoneClick' });
  steps.push({ type: 'disablePhone' });
  steps.push({ type: 'audio', urlRel: './scene2/18. Звонок между допросом 7 и 8.mp3' });

  // 19. Допрос 8 (ВЫБОР)
  steps.push({ type: 'showChoiceButtons' });
  steps.push({
    type: 'waitChoiceAndPlay',
    soft: { m1: './scene2/19.1 допрос 8 кам 1.mov', m2: './scene2/19.1 допрос 8 кам 2.mov' },
    tense: { m1: './scene2/19.2 допрос 8 кам 1.mov', m2: './scene2/19.2 допрос 8 кам 2.mov' }
  });

  // 20. Допрос 9 (ВЫБОР - между 8 и 9 звонка нет)
  steps.push({ type: 'showChoiceButtons' });
  steps.push({
    type: 'waitChoiceAndPlay',
    soft: { m1: './scene2/20.1 Допрос 9 кам 1.mov', m2: './scene2/20.1 Допрос 9 кам 2.mov' },
    tense: { m1: './scene2/20.2 Допрос 9 кам 1.mov', m2: './scene2/20.2 Допрос 9 кам 2.mov' }
  });

  // 21. Звонок
  steps.push({ type: 'enablePhone', labelText: 'Ответить на звонок' });
  steps.push({ type: 'waitPhoneClick' });
  steps.push({ type: 'disablePhone' });
  steps.push({ type: 'audio', urlRel: './scene2/21. Звонок между допросом 9 и 10.mp3' });

  // 22. Допрос 10 (ВЫБОР)
  steps.push({ type: 'showChoiceButtons' });
  steps.push({
    type: 'waitChoiceAndPlay',
    soft: { m1: './scene2/22.1 допрос 10 кам 1.mov', m2: './scene2/22.1 допрос 10 кам 2.mov' },
    tense: { m1: './scene2/22.2 допрос 10 кам 1.mov', m2: './scene2/22.2 допрос 10 кам 2 .mov' }
  });

  // 23. Звонок
  steps.push({ type: 'enablePhone', labelText: 'Ответить на звонок' });
  steps.push({ type: 'waitPhoneClick' });
  steps.push({ type: 'disablePhone' });
  steps.push({ type: 'audio', urlRel: './scene2/23. Звонок между допросом 10 и 11.mp3' });

  // 24. Допрос 11 (ВЫБОР)
  steps.push({ type: 'showChoiceButtons' });
  steps.push({
    type: 'waitChoiceAndPlay',
    soft: { m1: './scene2/24.1 допрос 11 кам 1.mov', m2: './scene2/24.1 допрос 11 кам 2.mov' },
    tense: { m1: './scene2/24.2 допрос 11 кам 1.mov', m2: './scene2/24.2 допрос 11 кам 2.mov' }
  });

  // 25. Звонок
  steps.push({ type: 'enablePhone', labelText: 'Ответить на звонок' });
  steps.push({ type: 'waitPhoneClick' });
  steps.push({ type: 'disablePhone' });
  steps.push({ type: 'audio', urlRel: './scene2/25. Звонок между допросом 11 и 12.mp3' });

  // 26. Допрос 12 (ВЫБОР)
  steps.push({ type: 'showChoiceButtons' });
  steps.push({
    type: 'waitChoiceAndPlay',
    soft: { m1: './scene2/26.1 допрос 12 кам 1.mov', m2: './scene2/26.1 допрос 12 кам 2.mov' },
    tense: { m1: './scene2/26.2 допрос 12 кам 1.mov', m2: './scene2/26.2 допрос 12 кам 2.mov' }
  });

  // 27. Допрос 13 (ЛИНЕЙНО)
  steps.push({ type: 'showNextButton', buttonText: 'Следующий допрос' });
  steps.push({ type: 'waitNextButtonClick' });
  steps.push({ type: 'hideNextButton' });
  steps.push({ type: 'videos', urlRel1: './scene2/27 допрос 13 кам 1.mov', urlRel2: './scene2/27 допрос 13 кам 2.mov' });

  //28 фаза 3 
  steps.push({ type: 'showNextButton', buttonText: 'Общий допрос' });
  steps.push({ type: 'waitNextButtonClick' });
  steps.push({ type: 'hideNextButton' });
  steps.push({ type: 'videos', urlRel1: './scene2/28. фаза 3 кам 1.mov', urlRel2: './scene2/28. фаза 3 кам 2.mov', leader: 'video1' });

  // 28. Финальный выбор
  // Новый шаг для выбора виновника (в самом конце)
  steps.push({
    type: 'waitAccusation',
    targets: [
      { name: 'Седа и Иван', id: 'win' },
      { name: 'Иван', id: 'lose' },
      { name: 'Захар', id: 'hint_zakhar' },
      { name: 'Артемий', id: 'hint_artemiy' }
    ]
  });

  return steps;
}

function mapDossierToUrls(d) {
  return {
    urlRel1: d.m1,
    urlRel2: d.m2,
    leader: 'video1',
  };
}